/// <reference path="./customKoBindings.d.ts" />
import * as ko from "knockout";
import * as $ from "jquery";
import * as AutoNumeric from "autonumeric";
import "chosen-js";
import "datatables.net";
import "jquery-ui/ui/widgets/autocomplete";

export class CustomBindingHandlers {

    static initCustomBinding() {
        ko.bindingHandlers.autoNumeric = {
            init: (element, valueAccessor, allBindings) => {
                let settingsFromBindig = allBindings.get('settings');
                let settings = {};
                switch (settingsFromBindig) {
                    case "newspaperQuantity": {
                        settings = {
                            decimalPlaces: 0,
                            digitGroupSeparator: ' ',
                            watchExternalChanges: true,
                            modifyValueOnWheel: false,
                            minimumValue: 0,
                            maximumValue: 100000
                        }
                        break;
                    }
                    case "price": {
                        settings = {
                            decimalPlaces: 0,
                            digitGroupSeparator: ' ',
                            watchExternalChanges: true,
                            modifyValueOnWheel: false,
                            minimumValue: 0
                        }
                        break;
                    }
                    default: {
                        settings = settingsFromBindig;
                    }
                }
                new AutoNumeric(element, settings);
            },
            update: (element, valueAccessor, allBindings) => {
                let value = valueAccessor();
                ko.unwrap(value); //The update function of a binding handler will run whenever the observables it accesses are updated.

                let num = AutoNumeric.getNumericString(element);
                value(num);
            }
        };

        ko.bindingHandlers.chosenJs = {
            init: (element, valueAccessor, allBindings) => {
                let allowDeselect = allBindings.get('allowDeselect');

                ko.bindingHandlers.options.init(element);

                $(element).chosen({
                    no_results_text: "Nem található...",
                    allow_single_deselect: allowDeselect,
                    search_contains: true
                });
            },
            update: (element, valueAccessor, allBindings) => {
                ko.unwrap(allBindings());

                ko.bindingHandlers.options.update(element, valueAccessor, allBindings);

                $(element).trigger("chosen:updated");
            }
        };

        ko.bindingHandlers.autocomplete = {
            init: (element) => {
                $(element).autocomplete();
            },
            update: (element, valueAccessor, allBindings) => {
                var sourceUrl = valueAccessor();
                var sourceUrlUnwrapped = ko.unwrap(sourceUrl);
                var filterData = allBindings.get("filterData");
                var filterDataUnwrapped = ko.unwrap(filterData);
                $(element).autocomplete("option", "source", (request: any, response: any) =>
                    $.getJSON(
                        sourceUrlUnwrapped,
                        { term: request.term, ...filterDataUnwrapped },
                        (data) => response(data)
                    ));
            }
        };

        ko.bindingHandlers.toUpperCaseTextInput = {
            init: (element, valueAccessor, allBindings) => {
                ko.bindingHandlers['textInput'].init(element, valueAccessor, allBindings);
            },
            update: (element, valueAccessor) => {
                let value = valueAccessor();          
                let unwrapValue = ko.unwrap(value);
                let capitalized = unwrapValue.toUpperCase();
                value(capitalized);
            }
        };
    }
}